import { Component, OnInit } from '@angular/core';
import { Functions, httpsCallable } from '@angular/fire/functions';
import { LoaderService } from '../../core/ui/loader';
import { AlertService } from '../../core/ui/alert';
import * as XLSX from 'xlsx';

@Component({
	selector: 'app-dashboard',
	standalone: true,
	imports: [],
	templateUrl: './dashboard.html',
	styleUrl: './dashboard.css'
})

export class Dashboard implements OnInit {
	constructor(private functions: Functions, private loaderService: LoaderService, private alertService: AlertService) {}

	async ngOnInit(): Promise<void> {
		/*
		this.loaderService.show();

		try {
			const emailTest   = httpsCallable(this.functions, 'sendEmailTest');
			const result: any = await emailTest();
			this.loaderService.hide();
			console.log(result.data);
		} catch(error: any) {
			this.alertService.error(error.code, 'Error');
			this.loaderService.hide();
		}
*/

	}

	/*
	async setRole() {
		this.loaderService.show();

		try {
			const setRole = httpsCallable(this.functions, 'setSuperAdminRole');
			const result  = await setRole();

			this.alertService.success(result.data ? (result.data as any).message : 'Rol de superadmin asignado con éxito.', 'Role asignado');
			this.loaderService.hide();
		} catch(error: any) {
			let errorMessage = 'Ocurrió un error inesperado al asignar el rol de superadmin.';

			if(error.code) {
				switch (error.code) {
					case 'internal':
						errorMessage = `Error interno del servidor: ${error.message}`;
					break;
					case 'unauthenticated':
						errorMessage = 'Necesitas iniciar sesión para realizar esta acción.';
					break;
					case 'unavailable':
						errorMessage = 'El servicio no está disponible en este momento. Inténtalo más tarde.';
					break;
					case 'invalid-argument':
						errorMessage = 'Argumentos inválidos proporcionados a la función.';
					break;
					case 'permission-denied':
                		errorMessage = 'No tienes permiso para realizar esta acción.';
                	break;
					case 'resource-exhausted':
                		errorMessage = 'Se han excedido los límites de uso. Por favor, inténtalo de nuevo más tarde.';
                	break;
					case 'deadline-exceeded':
                		errorMessage = 'La operación ha tardado demasiado en responder. Por favor, inténtalo de nuevo.';
                	break;
            		case 'network-request-failed':
                		errorMessage = 'Problemas de conexión. Por favor, verifica tu conexión a internet.';
                	break;
					default:
						errorMessage = `Error de Cloud Function (${error.code}): ${error.message}`;
					break;
				}
			}

			this.alertService.error(errorMessage, 'Error');
			this.loaderService.hide();
		}
	}
	*/
}
